import { Attr, BelongsTo, Model } from "spraypaint";
import ApplicationRecord from "./ApplicationRecord";
import Recruiter from "./Recruiter";
import Employer from "./Employer";

@Model()
class PreferredSupplier extends ApplicationRecord {
  static jsonapiType = "preferred_suppliers";

  @Attr() employerId: number;

  @Attr() recruiterId: number;

  @Attr() employerUserId: number;

  @Attr({ persist: false }) createdAt: string;

  @Attr({ persist: false }) updatedAt: string;

  @Attr() activeEngagementCount: number;

  @Attr() recruitmentFeeRate: number;

  @Attr() message: string;

  @BelongsTo(Recruiter) recruiter: Recruiter;

  @BelongsTo(Employer) employer: Employer;
}

export default PreferredSupplier;
